export const fixUnsupportedCharacterString = (str = '') => str
  .replaceAll('`', '\'')
  .replaceAll('´', '\'')
  .replaceAll('‘', '\'')
  .replaceAll('’', '\'')
  .replaceAll(String.fromCharCode(0x2007), ' ') // figure space
  .replaceAll(String.fromCharCode(0x202F), ' ') // narrow no-break space
  .replaceAll(String.fromCharCode(0xA0), ' '); // NonBreakingSpace

export const fixUnsupportedCharacters = ({ fields = [] } = {}) => {
  fields.forEach((field) => {
    const sections = field.sections || [];
    sections.forEach(({ blocks }) => {
      blocks.forEach((block) => {
        // eslint-disable-next-line no-param-reassign
        block.html = fixUnsupportedCharacterString(block.html);
      });
    });
  });
  return { fields };
};
